import React from "react";

const Button = ( props ) => {

  return (
    <button {...props}
      type="button" 
      id={ props.id ?? null } 
      name={ props.name ?? null } 
      disabled={ props.isDisabled ? true : null } 
      className={`msync-button ${props.className ? props.className : ''}`}
    >
      { props.children ? props.children : ( props.name ?? 'Submit') }
    </button>
  )

}

export default Button